import React, { Component } from 'react'
import AdvertisementsFireplace from './AdvertisementFireplace'
import { ADVERTISEMENT_FIREPLACE } from '../constants/advertisementTypes'
import getAdvertisementData from '../functions/getAdvertisementData'
import getCookie from '../functions/getCookie'

class AdvertisementFireplaceWrapper extends Component {
    constructor(props) {
        super(props)

        this.state = {
            advertisements: null,
            isScrolled: false
        }

        this.onScrollPage = this.onScrollPage.bind(this)
    }

    componentDidMount() {
        if(!pmkinoFrontVars.apiData.itemCollections || !pmkinoFrontVars.apiData.movies) {
            this.setState({
                advertisements:         null
            })
        } else {
            this.setState({
                advertisements:         pmkinoFrontVars.apiData.advertisements
            })
        }

        window.addEventListener('scroll', this.onScrollPage)

    }
    
    onScrollPage() {
        if (window.scrollY > window.innerHeight && this.state.isScrolled === false) {
            this.setState({
                isScrolled: true
            })
        }
    }
    
    render() {
        const { advertisements, isScrolled } = this.state
        const { showSmallVersion } = this.props
        const cookieExists = getCookie('fireplace')
        const isScrolledClass = isScrolled || cookieExists || showSmallVersion ? ' is-scrolled' : ''
        const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_FIREPLACE]) 
        
        return filteredAdvertisements[ADVERTISEMENT_FIREPLACE].length !== 0 && <AdvertisementsFireplace className={isScrolledClass} items={filteredAdvertisements[ADVERTISEMENT_FIREPLACE]} />
    }
}

export default AdvertisementFireplaceWrapper